<template>
    <div class="learners">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <div class="card" v-if="learners">

                        <div class="card-header border-0">
                            <div class="row">
                                <div class="col-6">
                                    <h3 class="mb-0 text-uppercase">{{ cohort.name }}: {{ $t('reports.cohort-learners') }}</h3>
                                </div>
                                <div class="col-6 text-right">
                                    <el-dropdown trigger="click" @command="openReport($event)">
                                        <base-button type="primary" class="dropdown-toggle btn-sm mr-0" @click.prevent.stop="">
                                            <i class="tim-icons icon-line-chart mr-1"></i> {{ $t('common.reports') }}
                                        </base-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="learners">
                                                {{ $t('reports.cohort-learners') }}
                                            </el-dropdown-item>
                                            <el-dropdown-item command="instructors">
                                                {{ $t('reports.cohort-instructors') }}
                                            </el-dropdown-item>
                                            <el-dropdown-item command="degrees">
                                                {{ $t('reports.cohort-degrees') }}
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                        </div>

                        <p class="card-body pt-0 text-sm" v-if="empty">{{ $t('dashboard.no-learner') }}</p>

                        <div v-if="!empty">
                            
                            <table-control :search="true" v-model="search"></table-control>

                            <el-table class="table-responsive table-flush"
                                    header-row-class-name="thead-light"
                                    :data="filteredLearners">

                                <el-table-column width="72">
                                    <template v-slot="{row}">
                                        <span class="avatar rounded-circle" :class="{'disabled': isWithdrawed(row)}" v-if="row.avatar">
                                            <img :src="row.avatar">
                                        </span>
                                    </template>
                                </el-table-column>

                                <el-table-column width="200">
                                    <template v-slot="{row}">
                                        <div :class="{'disabled': isWithdrawed(row)}" v-if="row.name">
                                            <h4 class="mb-0">
                                                {{row.name}}
                                            </h4>
                                            <small v-if="row.owner">
                                                {{ row.owner.name }}
                                            </small>
                                            <small v-if="row.entity">
                                                / {{ row.entity.name }}
                                            </small>
                                        </div>
                                        <div v-else>
                                            <h4 class="mb-0">
                                                TOTAL
                                            </h4>
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column align="center" class-name="degree" v-for="(registration, index) in registrations" :key="index" width="120">
                                    <div slot="header">
                                        {{ registration.degree.name }}
                                    </div>
                                    <template v-slot="{row}">
                                        <div v-if="progress(row, registration)">

                                            <base-progress type="info" :value="progress(row, registration)" v-if="!row.withdrawed">
                                            </base-progress>

                                            <span class="d-block" v-if="!row.withdrawed">
                                                <strong>{{ progress(row, registration) }}%</strong> {{ $t('dashboard.done').toLowerCase() }}
                                                <span v-if="remedials(row, registration)">
                                                    <br><strong>{{ remedials(row, registration) }}</strong> {{ $t('dashboard.remedial-s').toLowerCase() }}
                                                </span>
                                            </span>
                                        </div>
                                        <div class="other-cohorts" v-if="otherCohorts(row, registration)">
                                            <div v-for="(cohort, index) in otherCohorts(row, registration)" :key="index">
                                                {{ cohort.name }}
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column align="right" class-name="actions" min-width="130">
                                    <template v-slot="{row}">
                                        <div class="p-1" v-if="row.name">

                                            <base-button type="primary" size="sm" @click="openLearner(row)">
                                                {{ $t('dashboard.follow-up') }}
                                            </base-button>
                                        </div>
                                        
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                learners: null,
                registrations: null,
                cohort: {},
                search: '',
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/reports/cohorts/'+to.params.cohortId+'/learners')
            .then(resp => {
                next(vm => {
                    vm.learners = resp.data.data
                    vm.registrations = resp.data.included.registrations
                    vm.cohort = resp.data.included.cohort
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('reports.cohorts'),
                        route: '/astral/ui/reports/cohorts'
                    },
                    {
                        name: this.cohort.name,
                    },
                    {
                        name: this.$t('reports.cohort-learners'),
                    },
                ]
            },

            empty() {
                return this.learners && this.learners.length == 0 && !this.search
            },

            filteredLearners() {
                // Search filter.
                let learners = this.learners.filter(learner => !this.search
                    || learner.name.toLowerCase().includes(this.search.toLowerCase())
                )
                // Sorting.
                learners = learners.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
                learners.push(this.totalLearner)
                return learners;
            },

            totalLearner() {
                let totalState = {}
                this.registrations.map(registration => {
                    totalState[registration.id] = {
                        remedial_sessions: 0,
                        sessions_count: 0,
                        completed_sessions: 0,
                    }
                    for (const learner of this.learners) {
                        const state = this.state(learner, registration)
                        if (!state) {
                            continue
                        }
                        totalState[registration.id].remedial_sessions += state.remedial_sessions
                        totalState[registration.id].sessions_count += state.sessions_count
                        totalState[registration.id].completed_sessions += state.completed_sessions
                    }
                })
                return { state: totalState }
            }
        },

        methods: {

            state(learner, registration) {
                return learner.state && learner.state[registration.id]
            },

            progress(learner, registration) {
                const state = this.state(learner, registration)
                if (!state || state.sessions_count == 0) {
                    return 0
                }
                let progress = (state.completed_sessions ? state.completed_sessions : 0) * 100 / state.sessions_count
                return parseInt(progress)
            },

            remedials(learner, registration) {
                const state = this.state(learner, registration)
                if (!state) {
                    return 0
                }
                return state.remedial_sessions
            },

            otherCohorts(learner, registration) {
                const state = this.state(learner, registration)
                if (!state || !state.other_cohorts || state.other_cohorts.length == 0) {
                    return false
                }
                return state.other_cohorts
            },

            isWithdrawed(learner) {
                return !learner.pivot.active
            },

            openLearner(learner) {
                this.$router.push({ name: 'dashboard-learner', params: { learnerId: learner.id } })
            },

            openReport(report) {
                this.$router.push({ name: 'report-cohort-' + report, params: { cohortId: this.cohort.id } })
            },
        }
    }
</script>

<style scoped>

    .learners >>> th,
    .learners >>> td {
        padding-right: 0;
    }
    .learners >>> td.degree {
        padding-right: .5rem;
        padding-left: .5;
    }
    .learners >>> td:has(.other-cohorts) {
        background-color: #f6f9fc !important;
        padding: 0;
    }
    .learners >>> th.actions,
    .learners >>> td.actions {
        padding-right: 1.5rem;
        padding-left: 0;
    }
    .learners >>> .table-control form {
        width: 100%;
    }
    .disabled, .disabled h4 {
        color: #bbb !important;
    }
    .disabled img {
        opacity: 0.5;
    }
    
</style>
